"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemActions = void 0;
var _mui = require("@ori-ui/mui");
var _context = require("../context");
var _logger = require("../logger");
var _Actions = require("./Actions");
var _jsxRuntime = require("react/jsx-runtime");
const Actions = (0, _mui.styled)('div')(({
  ownerState: {
    isSmall
  },
  theme
}) => ({
  gridArea: 'actions',
  boxSizing: 'content-box',
  width: '100%',
  overflow: 'hidden',
  display: 'grid',
  gridTemplateColumns: '1fr 115px',
  columnGap: theme.spacing(3),
  padding: '4px 4px 10px 5px',
  margin: '-4px -4px -10px -5px',
  ...(!isSmall && {
    [theme.breakpoints.up('md')]: {
      alignSelf: 'end'
    }
  })
}));
const FirstPart = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  gap: theme.spacing(3),
  flexFlow: 'row wrap'
}));
const SecondPart = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-end'
}));
const ItemActions = () => {
  const {
    code,
    hideActionSection,
    hideQuantity,
    isBundleItem,
    isSmall,
    lineNumber,
    quantity
  } = (0, _context.useItemContext)();
  (0, _logger.logDebug)(`${lineNumber}-${code} -> ItemActions quantity: ${quantity}`);
  if (hideActionSection) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Actions, {
    ownerState: {
      isSmall: isSmall ?? false
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FirstPart, {
      children: isBundleItem ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Actions.ItemButtons, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SecondPart, {
      children: hideQuantity ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Actions.ItemQuantity, {})
    })]
  });
};
exports.ItemActions = ItemActions;
//# sourceMappingURL=ItemActions.js.map